import intersection from 'lodash/intersection';
import { UserInfo } from '../stores/models/user';
import { UserRole } from '../types/enums';

export function hasRoles(userRoles: string[], roles: UserRole[]) {
  const containedRoles = intersection(userRoles, roles);
  return containedRoles.length > 0 && containedRoles[0] != null && containedRoles[0].trim() != '';
}

export function isAdmin(user: UserInfo) {
  return hasRoles(user.roleStrings, [UserRole.Admin, UserRole.SuperAdmin]);
}
